import f, { useRef as l, useEffect as h, Component as m, createElement as c, createContext as E } from "react";
function C({
  remote: u,
  fallback: e
}) {
  return ({ ...n }) => {
    const r = l(null), t = l(
      null
    );
    return h(() => {
      let o = null;
      const s = setTimeout(() => {
        t.current || (t.current = u.default()), o = r.current, o && t.current.render({
          ...n,
          dom: o,
          fallback: e
        });
      });
      return () => {
        clearTimeout(s), setTimeout(() => {
          var a;
          o && ((a = t.current) == null || a.destroy({ dom: o }));
        });
      };
    }, [n]), /* @__PURE__ */ f.createElement("div", { ref: r });
  };
}
const g = E(null), i = {
  didCatch: !1,
  error: null
};
class v extends m {
  constructor(e) {
    super(e), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = i;
  }
  static getDerivedStateFromError(e) {
    return {
      didCatch: !0,
      error: e
    };
  }
  resetErrorBoundary() {
    const {
      error: e
    } = this.state;
    if (e !== null) {
      for (var n, r, t = arguments.length, o = new Array(t), s = 0; s < t; s++)
        o[s] = arguments[s];
      (n = (r = this.props).onReset) === null || n === void 0 || n.call(r, {
        args: o,
        reason: "imperative-api"
      }), this.setState(i);
    }
  }
  componentDidCatch(e, n) {
    var r, t;
    (r = (t = this.props).onError) === null || r === void 0 || r.call(t, e, n);
  }
  componentDidUpdate(e, n) {
    const {
      didCatch: r
    } = this.state, {
      resetKeys: t
    } = this.props;
    if (r && n.error !== null && p(e.resetKeys, t)) {
      var o, s;
      (o = (s = this.props).onReset) === null || o === void 0 || o.call(s, {
        next: t,
        prev: e.resetKeys,
        reason: "keys"
      }), this.setState(i);
    }
  }
  render() {
    const {
      children: e,
      fallbackRender: n,
      FallbackComponent: r,
      fallback: t
    } = this.props, {
      didCatch: o,
      error: s
    } = this.state;
    let a = e;
    if (o) {
      const d = {
        error: s,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof n == "function")
        a = n(d);
      else if (r)
        a = c(r, d);
      else if (t !== void 0)
        a = t;
      else
        throw s;
    }
    return c(g.Provider, {
      value: {
        didCatch: o,
        error: s,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, a);
  }
}
function p() {
  let u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return u.length !== e.length || u.some((n, r) => !Object.is(n, e[r]));
}
export {
  v as E,
  C as c
};
